module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"title":"会社説明会絞り込み","description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"title":{"period":"開催期間","industry":"業種","prefecture":"開催地","company_type":"企業のタイプ"},"label":{"free_word":"フリーワード","select":"選択","freeword_text":"ex. 企業名、職種名など"}}}')
  delete Component.options._Ctor
}
